import { PERMISSIONS_NAME } from 'consts/permissions/permissions';
import { AppActions } from 'types';
import { useAppAbility } from '../useAppAbility';

export const useCalendarAbilities = () => {
    const ability = useAppAbility();

    const calendarAbilities = {
        checkIfCanViewEvents: () => ability.can(AppActions.VIEW, PERMISSIONS_NAME.EVENTS),
        checkIfCanManageEvents: () => ability.can(AppActions.EDIT_AND_ADD, PERMISSIONS_NAME.EVENTS),
    };

    return { calendarAbilities };
};
